<app-view-item *ngIf="readonly" [text]="selected ? selected.code + ' - ' + selected.name : ''"></app-view-item>

<nz-select *ngIf="!readonly"
  #selector
  nzShowSearch
  nzServerSearch
  [nzAllowClear]="true"
  [nzBackdrop]="addBackdrop"
  [nzFilterOption]="nzFilterOption"
  (nzOnSearch)="search($event, 20)"
  (nzOpenChange)="search('')"
  (nzScrollToBottom)="loadMore()"
  [nzCustomTemplate]="displayTpl"
  [(ngModel)]="value"
  (ngModelChange)="valueChanged($event)"
  [nzDropdownMatchSelectWidth]="false"
  [nzBorderless]="borderless"
  [nzDropdownRender]="renderTemplate"
  [nzDisabled]="allowEdit === false"
  class="width-100"
>
  <ng-template #displayTpl let-selected>
    {{ selected.nzLabel }}
  </ng-template>
  <ng-container *ngFor="let o of list">
    <nz-option *ngIf="!searching" 
      [nzValue]="getValue(o)" 
      [nzLabel]="o.code + ' - ' + o.name" 
      nzCustomContent>
        <div class="dropdown-container">
            <strong>{{ o?.code }}</strong>
            -
            <span> {{ o?.name }}</span>
            <nz-tag *ngIf="o.isDefault" nzColor="success">Default</nz-tag>
          </div>
    </nz-option>
  </ng-container>
</nz-select>

<ng-template #renderTemplate>
  <!-- <div class="text-center" *ngIf="!this.NotShowInReport">
    <button type="button" nz-button nzType="primary" (click)="addNew()" [acl]="{ ability: ['einv-multi-msic.create'], mode: 'allOf' }">
      <span nz-icon nzType="plus"></span>
      {{ instantData ? ' Add New \''+ instantData +'\'' : ' Add New' }}
    </button>
  </div> -->
</ng-template>